<template>
  <div class="card">
    <div class="card-body">
      <div class="flex items-center justify-between">
        <div>
          <p class="text-sm text-gray-500">{{ title }}</p>
          <p class="text-2xl font-bold" :class="getValueColor()">{{ value }}</p>
          <div v-if="change !== undefined" class="flex items-center mt-1">
            <component :is="getChangeIcon()" class="w-4 h-4 mr-1" :class="getChangeColor()" />
            <span class="text-sm" :class="getChangeColor()">
              {{ Math.abs(change) }}{{ change > 0 ? '% increase' : change < 0 ? '% decrease' : ' no change' }}
            </span>
          </div>
        </div>
        <div class="flex-shrink-0">
          <component :is="getIcon()" class="w-8 h-8" :class="getIconColor()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { 
  UserGroupIcon, 
  PhoneIcon, 
  HeartIcon, 
  ExclamationTriangleIcon,
  ArrowTrendingUpIcon,
  ArrowTrendingDownIcon,
  ArrowRightIcon
} from '@heroicons/vue/24/outline'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  value: {
    type: [String, Number],
    required: true
  },
  change: {
    type: Number,
    default: undefined
  },
  icon: {
    type: String,
    default: 'users'
  },
  color: {
    type: String,
    default: 'primary'
  }
})

function getIcon() {
  const icons = {
    users: UserGroupIcon,
    phone: PhoneIcon,
    heart: HeartIcon,
    alert: ExclamationTriangleIcon
  }
  return icons[props.icon] || UserGroupIcon
}

function getIconColor() {
  const colors = {
    primary: 'text-primary-500',
    success: 'text-success-500',
    warning: 'text-warning-500',
    danger: 'text-danger-500',
    info: 'text-info-500'
  }
  return colors[props.color] || 'text-primary-500'
}

function getValueColor() {
  const colors = {
    primary: 'text-primary-600',
    success: 'text-success-600',
    warning: 'text-warning-600',
    danger: 'text-danger-600',
    info: 'text-info-600'
  }
  return colors[props.color] || 'text-gray-900'
}

function getChangeIcon() {
  if (props.change > 0) return ArrowTrendingUpIcon
  if (props.change < 0) return ArrowTrendingDownIcon
  return ArrowRightIcon
}

function getChangeColor() {
  if (props.change > 0) return 'text-success-600'
  if (props.change < 0) return 'text-danger-600'
  return 'text-gray-500'
}
</script>